module.exports = __webpack_public_path__ + "img/unAuthorized.5965a503.png";